import React, { useState, useEffect, useRef } from 'react';
import API from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import toast from 'react-hot-toast';

export default function Agente() {
  const { usuario } = useAuth();
  const [mensajes, setMensajes] = useState([]);
  const [input, setInput] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [cargando, setCargando] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    API.get('/app/agente/mensajes')
      .then(r => { setMensajes(r.data); setCargando(false); })
      .catch(() => setCargando(false));
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [mensajes]);

  const enviar = async () => {
    const texto = input.trim();
    if (!texto || enviando) return;
    setInput('');
    setEnviando(true);

    // Agregar mensaje del usuario optimistamente
    const msgTemp = { id: Date.now(), rol: 'usuario', contenido: texto, created_at: new Date().toISOString() };
    setMensajes(ms => [...ms, msgTemp]);

    try {
      const r = await API.post('/app/agente/mensaje', { contenido: texto });
      const msgAgente = {
        id: Date.now() + 1, rol: 'agente',
        contenido: r.data.respuesta, created_at: new Date().toISOString()
      };
      setMensajes(ms => [...ms, msgAgente]);
    } catch {
      toast.error('Error al enviar mensaje');
      setMensajes(ms => ms.filter(m => m.id !== msgTemp.id));
    } finally { setEnviando(false); }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); enviar(); }
  };

  const fmtHora = (d) => {
    try { return format(new Date(d), 'HH:mm', { locale: es }); } catch { return ''; }
  };

  const fmtFecha = (d) => {
    try { return format(new Date(d), "d 'de' MMMM", { locale: es }); } catch { return ''; }
  };

  // Agrupar mensajes por fecha
  const grupos = mensajes.reduce((acc, m) => {
    const fecha = m.created_at?.slice(0, 10) || '';
    if (!acc[fecha]) acc[fecha] = [];
    acc[fecha].push(m);
    return acc;
  }, {});

  const SUGERENCIAS = [
    '¿Cómo vamos hoy?',
    '¿Qué debo pedir esta semana?',
    '¿Cuál PDV tiene mejor margen este mes?',
    '¿Hay algo que deba atender?',
  ];

  return (
    <div style={{ display:'flex', flexDirection:'column', flex:1, minHeight:0, height:'100%' }}>
      {/* Header */}
      <div style={{ display:'flex', alignItems:'center', gap:12, marginBottom:12, paddingBottom:12, borderBottom:'1px solid #E5E7EB' }}>
        <div style={{ width:42, height:42, borderRadius:'50%', background:'#1a1a2e', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20 }}>
          🤖
        </div>
        <div>
          <div style={{ fontWeight:800, fontSize:16, color:'#111827' }}>Latu</div>
          <div style={{ fontSize:12, color:'#059669', fontWeight:600 }}>● Agente de inteligencia Gelatus</div>
        </div>
      </div>

      {/* Mensajes */}
      <div style={{ flex:1, overflowY:'auto', minHeight:0, paddingRight:4, paddingLeft:4 }}>
        {cargando ? (
          <div style={{ textAlign:'center', padding:40, color:'#9CA3AF' }}>Cargando conversación...</div>
        ) : mensajes.length === 0 ? (
          <div style={{ textAlign:'center', padding:'30px 16px' }}>
            <div style={{ fontSize:48, marginBottom:12 }}>🤖</div>
            <div style={{ fontWeight:700, fontSize:16, color:'#111827', marginBottom:6 }}>Hola, soy Latu</div>
            <div style={{ fontSize:13, color:'#6B7280', lineHeight:1.6, marginBottom:20 }}>
              Soy el agente de inteligencia de Gelatus. Analizo los datos de tu negocio y te aviso cuando encuentro algo valioso. También puedes preguntarme lo que quieras.
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {SUGERENCIAS.map(s => (
                <button key={s} onClick={() => { setInput(s); }}
                  style={{ padding:'10px 16px', background:'white', border:'2px solid #E5E7EB', borderRadius:20, fontSize:13, cursor:'pointer', color:'#374151', textAlign:'left' }}>
                  {s}
                </button>
              ))}
            </div>
          </div>
        ) : (
          Object.entries(grupos).map(([fecha, msgs]) => (
            <div key={fecha}>
              <div style={{ textAlign:'center', margin:'12px 0' }}>
                <span style={{ background:'#F3F4F6', color:'#6B7280', fontSize:11, padding:'3px 10px', borderRadius:20 }}>
                  {fmtFecha(msgs[0].created_at)}
                </span>
              </div>
              {msgs.map(m => (
                <div key={m.id} style={{ display:'flex', justifyContent: m.rol==='usuario'?'flex-end':'flex-start', marginBottom:10 }}>
                  {m.rol === 'agente' && (
                    <div style={{ width:28, height:28, borderRadius:'50%', background:'#1a1a2e', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, marginRight:6, flexShrink:0, alignSelf:'flex-end' }}>
                      🤖
                    </div>
                  )}
                  <div style={{ maxWidth:'78%' }}>
                    <div style={{
                      padding:'10px 14px', borderRadius: m.rol==='usuario'?'18px 18px 4px 18px':'18px 18px 18px 4px',
                      background: m.rol==='usuario'?'#1a1a2e':'white',
                      color: m.rol==='usuario'?'white':'#111827',
                      fontSize:14, lineHeight:1.6,
                      boxShadow: m.rol==='agente'?'0 1px 3px rgba(0,0,0,0.07)':'none',
                      border: m.tipo==='proactivo'?'2px solid #FDE68A':'none',
                    }}>
                      {m.tipo==='proactivo' && (
                        <div style={{ fontSize:11, color:'#92400E', fontWeight:700, marginBottom:4 }}>💡 Observación proactiva</div>
                      )}
                      {m.contenido.split('\n').map((l, i) => <div key={i}>{l || <br/>}</div>)}
                    </div>
                    <div style={{ fontSize:10, color:'#9CA3AF', marginTop:3, textAlign: m.rol==='usuario'?'right':'left' }}>
                      {fmtHora(m.created_at)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
        {enviando && (
          <div style={{ display:'flex', justifyContent:'flex-start', marginBottom:10 }}>
            <div style={{ width:28, height:28, borderRadius:'50%', background:'#1a1a2e', display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, marginRight:6 }}>🤖</div>
            <div style={{ background:'white', borderRadius:'18px 18px 18px 4px', padding:'12px 16px', boxShadow:'0 1px 3px rgba(0,0,0,0.07)' }}>
              <div style={{ display:'flex', gap:4 }}>
                {[0,1,2].map(i => (
                  <div key={i} style={{ width:6, height:6, borderRadius:'50%', background:'#9CA3AF', animation:`bounce 1s ${i*0.2}s infinite` }} />
                ))}
              </div>
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div style={{ paddingTop:10, paddingBottom:8, borderTop:'1px solid #E5E7EB', display:'flex', gap:8, alignItems:'flex-end' }}>
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={handleKey}
          placeholder="Pregúntale a Latu..."
          rows={1}
          style={{ flex:1, padding:'10px 14px', border:'2px solid #E5E7EB', borderRadius:20, fontSize:14, outline:'none', resize:'none', fontFamily:'inherit', lineHeight:1.4, maxHeight:100, overflowY:'auto' }}
        />
        <button onClick={enviar} disabled={!input.trim() || enviando}
          style={{ width:42, height:42, borderRadius:'50%', background: input.trim()?'#1a1a2e':'#E5E7EB', border:'none', cursor: input.trim()?'pointer':'default', fontSize:18, display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          {enviando ? '⏳' : '➤'}
        </button>
      </div>

      <style>{`
        @keyframes bounce {
          0%, 60%, 100% { transform: translateY(0); }
          30% { transform: translateY(-6px); }
        }
      `}</style>
    </div>
  );
}
